<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <div class="solutionCaseBanner">
        <div class="solutionCaseBannerIn">智慧政务解决方案</div>
    </div>
    <section class="solutionConcept">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/solutionConceptPic2.jpg" />
          </div>
          <div class="solutionConceptBoxL">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">项目概念</div>
              <div class="solutionConceptInConn">
                智慧政务作为政府的对外服务窗口，方便互联网用户了解政府最新资讯，以及办理各项业务，提升政府服务效率，而互联网用户归类包括IPv4和IPv6用户，所以需要实现对IPv6用户的同步覆盖。
              </div>
            </div>
            <div class="solutionConceptArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="solutionIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit">客户收益</div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon05.png" />
            <div class="solutionIncomeConn">
              提升智慧政务网站<br />及应用安全使用级别
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon06.png" />
            <div class="solutionIncomeConn">
              快速实现政府各类<br />公共资源充分共享
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon07.png" />
            <div class="solutionIncomeConn">
              解决政府各委办局<br />“信息孤岛”问题
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon04.png" />
            <div class="solutionIncomeConn">
              提高基于下一代互联网<br />定位大数据分析的精准度
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="solutionAdvantage">
      <div class="solutionAdvantageBox">
        <div class="solutionAdvantageTit">项目优势</div>
        <img
          src="../../../static/images/solutionAdvantageIcon02.png"
          style="margin-top: 26px"
        />
        <div class="solutionAdvantageConn" style="left: 356px; top: 143px">
          <div class="solutionAdvantageConnSlogan">全新的IPv6政务系统</div>
        </div>
        <div class="solutionAdvantageConn" style="right: 248px; top: 260px">
          <div class="solutionAdvantageConnSlogan">培养新市场、新业态</div>
        </div>
        <div class="solutionAdvantageConn" style="right: 356px; bottom: 77px">
          <div class="solutionAdvantageConnSlogan">提高数据分析精准度</div>
        </div>
        <div class="solutionAdvantageConn" style="left: 246px; bottom: 184px">
          <div class="solutionAdvantageConnSlogan">网络信息与安全保障</div>
        </div>
      </div>
    </section>
    <section class="solutionValue">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit">项目价值</div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionValuePic01.png" />
            <div class="solutionIncomeConn">
              响应国家政策：<br />超前布局下一代互联网
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic02.png" />
            <div class="solutionIncomeConn">
              树立政府形象：<br />提升信息化建设水平
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic03.png" />
            <div class="solutionIncomeConn">
              促进招商引资：<br />吸引创新型企业投资
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic05.png" />
            <div class="solutionIncomeConn">
              推动产业转型：<br />提升区域经济的优势
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic04.png" />
            <div class="solutionIncomeConn">
              提升用户覆盖面：<br />同时支持IPv4和IPv6
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage:'../../../static/images/solutionCaseBanner2.jpg?011901',
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./solution";
.solutionCase {
    .solutionCaseBanner{
         background:url(../../../static/images/solutionCaseBanner2.jpg?011902) no-repeat center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/solutionCase1.vue